<div class="container p-4 p-md-5" id="finalize-payment-page">
    <div class="d-flex justify-content-end">
        <app-button id="back-desktop" [onlyIcon]="true" [isIcon]="true" [left]="true" [iconName]="'bi bi-arrow-left'"
            [buttonOptions]="backOptions" (buttonClick)="back()">
        </app-button>
    </div>
    <div class="logo-sou-mais-fc-page p-3 text-center">
        <img [src]="logoUrl" alt="Logo" />
    </div>
    <div class="finalize-payment-main-title my-4 text-center" [style.color]="labelColor">
        {{ pageTitle }}
    </div>
    <div class="row">
        <form class="col-md-8" [formGroup]="finalizePaymentformGroup">
            <!-- Select de Experiências -->
            <app-select-input class="col" [id]="'experienceInputId'" [label]="'Experiências'"
                [options]="experienceOptions" formControlName="experienceControl" (change)="onExperienceChange()">
            </app-select-input>

            <div class="py-2"></div>

            <!-- Formas de Pagamento -->
            <div *ngIf="formOfPaymentOptions.length > 0 && selectedExperience" class="payment-method-options">
                <app-toggle-button class="col" [id]="'formOfPaymentInputId'" [label]="'Forma de Pagamento'"
                    [toggleButtonOptions]="formOfPaymentOptions" [color]="'#FFFFFF'"
                    [formControlValue]="finalizePaymentformGroup.controls.formOfPaymentControl"
                    [class.disabled]="(useBalanceControl.value ?? false) && memberScore >= (selectedExperience?.requiredPoints || 0)">
                </app-toggle-button>
            </div>

            <!-- Campos do Cartão de Crédito -->
            <div *ngIf="showCreditCardOptions && selectedExperience" class="payment-additional-info mt-4 fs-small">
                <form [formGroup]="creditCardformGroup">
                    <div class="row">
                        <app-input-custom class="col-12 col-md-6" [id]="'cardNumberInputId'"
                            [placeholder]="'Insira o número do cartão'" [label]="'Número do cartão'"
                            [mask]="InputMaskTypesEnum.CREDIT_CARD" formControlName="cardNumberControl"
                            [disabled]="(useBalanceControl.value ?? false) && memberScore >= (selectedExperience?.requiredPoints || 0)"></app-input-custom>
                        <app-input-custom class="col-md-6" [id]="'expirationDateInputId'" [placeholder]="'MM/AA'"
                            [label]="'Data de validade'" [mask]="InputMaskTypesEnum.MES_ANO"
                            [dropSpecialCharacters]="false" formControlName="expirationDateControl"
                            [disabled]="(useBalanceControl.value ?? false) && memberScore >= (selectedExperience?.requiredPoints || 0)"></app-input-custom>
                    </div>
                    <div class="row">
                        <app-input class="col-md-6" [id]="'cvvInputId'" [label]="'CVV'" [placeholder]="'CVV'"
                            [type]="InputTypeEnum.NUMBER" [maxLength]="3" [minLength]="3" formControlName="cvvControl"
                            [disabled]="(useBalanceControl.value ?? false) && memberScore >= (selectedExperience?.requiredPoints || 0)"></app-input>

                        <app-select-input class="col-md-6" [id]="'numberOfInstallmentsInputId'"
                            [label]="'Nº de parcelas'" [options]="numberOfInstallmentsOptions"
                            formControlName="numberOfInstallmentsControl">
                        </app-select-input>

                    </div>
                    <div class="row">
                        <app-input-custom class="col-md-12" [id]="'CPFInputId'" [label]="'CPF'"
                            [mask]="InputMaskTypesEnum.CPF" [placeholder]="'Insira o CPF do titular'"
                            formControlName="CPFControl"
                            [disabled]="(useBalanceControl.value ?? false) && memberScore >= (selectedExperience?.requiredPoints || 0)"></app-input-custom>
                    </div>

                    <div class="row">
                        <app-input class="col" [id]="'cardNameInputId'" [label]="'Nome do cartão'"
                            [placeholder]="'Insira o nome do titular do cartão'" formControlName="cardNameControl"
                            [disabled]="(useBalanceControl.value ?? false) && memberScore >= (selectedExperience?.requiredPoints || 0)"></app-input>
                    </div>

                </form>
            </div>
        </form>

        <!-- Sumário -->
        <div class="col-md-4 summary-payment">
            <!-- Sempre exibir Saldo e Botão de Utilizar Saldo -->
            <div class="mt-4 row align-items-center">
                <div class="col-6">
                    <app-checkbox class="col" [id]="'useBalanceCheckboxId'" [label]="'Utilizar saldo '"
                        [formControl]="useBalanceControl">
                    </app-checkbox>
                </div>
                <div class="col-6 text-end">
                    <span class="fs-small">Saldo: {{ memberScore }} pontos</span>
                </div>
            </div>

            <div class="my-4">Resumo</div>

            <div *ngIf="selectedExperience">
                <div class="row my-3">
                    <div class="col-7 fs-small">
                        {{ selectedExperience?.name || selectedExperience?.title }} -
                        {{ selectedExperience?.description || selectedExperience?.content }}
                    </div>
                    <div class="col-5">
                        <div class="fs-small fw-medium d-flex justify-content-end">
                            {{
                            selectedExperience.value > 0
                            ? (selectedExperience.value | customCurrency)
                            : "Gratuito"
                            }}
                        </div>
                    </div>
                </div>

                <!-- Linha para exibir o desconto do saldo -->
                <div class="row mb-3" *ngIf="useBalanceControl.value && balanceUsed > 0">
                    <div class="col-7 fs-small">Saldo utilizado</div>
                    <div class="col-5">
                        <div class="fs-small fw-medium d-flex justify-content-end">
                            -{{ balanceUsed }} pontos
                        </div>
                    </div>
                </div>

                <hr class="my-3" />

                <div class="row mb-3">
                    <div class="col-7 fs-small">Saldo restante</div>
                    <div class="col-5">
                        <div class="fs-small fw-medium d-flex justify-content-end">
                            {{ remainingBalance }} pontos
                        </div>
                    </div>
                </div>

                <div class="row mb-3"
                    *ngIf="selectedExperience?.feeValue !== null && (!useBalanceControl.value || memberScore < selectedExperience.value)">
                    <div class="col-7 fs-small">Taxa</div>
                    <div class="col-5">
                        <div class="fs-small fw-medium d-flex justify-content-end">
                            {{
                            selectedExperience.isFeePercentage
                            ? ((selectedExperience.value * (selectedExperience.feeValue || 0)) / 100 | customCurrency)
                            : (selectedExperience.feeValue | customCurrency)
                            }}
                        </div>
                    </div>
                </div>

                <div class="row mb-3" *ngIf="selectedExperience.discount > 0">
                    <div class="col-7 fs-small">DESCONTO</div>
                    <div class="col-5">
                        <div class="fs-small fw-medium d-flex justify-content-end">
                            {{ selectedExperience.discount | customCurrency }}
                        </div>
                    </div>
                </div>
                <div class="row mb-3" *ngIf="selectedExperience.couponDiscount > 0">
                    <div class="col-7 fs-small">DESCONTO CUPOM</div>
                    <div class="col-5">
                        <div class="fs-small fw-medium d-flex justify-content-end">
                            {{ selectedExperience.couponDiscount | customCurrency }}
                        </div>
                    </div>
                </div>
                <div class="row mb-3" *ngIf="adjustedExperienceValue !== null && adjustedExperienceValue > 0">
                    <div class="col-7 fs-small">TOTAL</div>
                    <div class="col-5">
                        <div class="fs-small fw-medium d-flex justify-content-end">
                            {{
                            adjustedExperienceValue !== null
                            ? (adjustedExperienceValue +
                            (selectedExperience?.value > 0
                            ? (selectedExperience?.isFeePercentage
                            ? (selectedExperience.value * (selectedExperience.feeValue || 0)) / 100
                            : (selectedExperience.feeValue || 0))
                            : 0) | customCurrency)
                            : ((selectedExperience?.discountedAmount ?? selectedExperience?.value) | customCurrency)
                            }}
                        </div>
                    </div>
                </div>
            </div>

            <div class="mt-4 row">
                <app-button class="col w-100" [disabled]="
                finalizePaymentformGroup.invalid ||
                (memberScore < selectedExperience?.requiredPoints && creditCardformGroup.invalid) ||
                submitCount > 0
                " [buttonOptions]="buttonOptions" (buttonClick)="save()"></app-button>
                <p class="pt-2 small text-center" *ngIf="submitCount > 0">
                    Novo envio em {{ submitCount }} segundo(s)
                </p>
            </div>
        </div>
    </div>
</div>
<app-payment-modal [modalId]="modalId" [paymentType]="paymentType" [paymentModalData]="paymentModalData"
    (confirmActionChange)="onModalConfirm()"></app-payment-modal>